import React, { useState, useEffect } from 'react';
import { authFetch } from '../utils/api';
import { useTheme } from '../contexts/ThemeContext';
import { THEME_COLORS } from '../components/Constants';

const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);
};

export default function AnnualBudgetCell({ person_id, catId, year, currentTotal, onUpdate }) {
    const { currentTheme } = useTheme();
    const themeColors = THEME_COLORS[currentTheme] || THEME_COLORS.blue;
    const [isEditing, setIsEditing] = useState(false);
    
    // On synchronise la valeur temporaire avec le total réel calculé par le parent
    const [tempValue, setTempValue] = useState(currentTotal);

    useEffect(() => {
        setTempValue(currentTotal);
    }, [currentTotal]);

    const handleSave = async () => {
        try {
            // ⭐ On utilise la route /annual pour répartir le montant sur l'année
            await authFetch.post('/budgets/annual', {
                person_id: person_id,
                categorie_id: catId,
                year: year,
                total_annual: parseFloat(tempValue) // Utilise tempValue qui existe bien ici
            });
            setIsEditing(false);
            onUpdate(); // Rafraîchit les données du tableau
        } catch (err) {
            console.error("Erreur lors de la mise à jour annuelle:", err);
        }
    };

    return (
        <td 
            onClick={() => { if(!isEditing) setIsEditing(true); }}
            style={{
                padding: '5px',
                border: '1px solid #ccc',
                textAlign: 'right',
                fontWeight: 'bold',
                backgroundColor: isEditing ? '#fff' : '#e8f5e9', // Couleur spécifique Annuel
                cursor: 'pointer',
                minWidth: '100px'
            }}
        >
            {isEditing ? (
                <input 
                    autoFocus
                    type="number"
                    step="0.01"
                    value={tempValue}
                    onChange={(e) => setTempValue(e.target.value)}
                    onBlur={handleSave}
                    onKeyDown={(e) => e.key === 'Enter' && handleSave()}
                    style={{ width: '80px', textAlign: 'right', border: '1px solid ' + themeColors.primary }}
                />
            ) : (
                <span>{formatCurrency(currentTotal)} €</span>
            )}
        </td>
    );
}